export enum LocalStorageKey {
  Theme = 'theme',
}
